// extracted by mini-css-extract-plugin
module.exports = {"sp-220w-single":"SP220wSingle_sp-220w-single__GHrVz"};